/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const MoreHorizontalIcon = createIcon({
    displayName: 'MoreHorizontalIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M8.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M3.53 10.436c.32-.29.8-.436 1.47-.436.585 0 1.048.134 1.38.402.409.33.62.862.62 1.598 0 .672-.14 1.172-.46 1.504-.321.332-.821.496-1.54.496-.658 0-1.138-.144-1.463-.436C3.168 13.234 3 12.714 3 12c0-.708.16-1.231.53-1.564ZM12 10c-.67 0-1.15.146-1.47.436-.37.333-.53.856-.53 1.564 0 .714.168 1.234.537 1.564.325.292.805.436 1.463.436.719 0 1.219-.164 1.54-.496.32-.332.46-.832.46-1.504 0-.736-.211-1.269-.62-1.598-.332-.268-.795-.402-1.38-.402Zm7 0c-.67 0-1.15.146-1.47.436-.37.333-.53.856-.53 1.564 0 .714.169 1.234.537 1.564.325.292.805.436 1.463.436.719 0 1.219-.164 1.54-.496.32-.332.46-.832.46-1.504 0-.736-.211-1.269-.62-1.598-.332-.268-.795-.402-1.38-.402Z"
        })
    ]
});
MoreHorizontalIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'MoreHorizontalIcon'
};
export { MoreHorizontalIcon };

//# sourceMappingURL=more-horizontal.js.map